import { useState } from "react";
import { call } from "../funcStore";
import Header from "../components/layout/Header";
import MainTabs from "../components/layout/MainTabs";
import Footer from "../components/layout/Footer";
import { sendContact } from "../api/contactApi";
import { logAction } from "../api/logApi";

// どの画面から遷移してきたかを本文の先頭に自動挿入する
// (detail画面ならVTuberのid/name、search画面なら検索条件を添える。App.jsのbuildContactContext参照)
function buildInitialMessage() {
  const context = call("app.getContactContext");
  if (!context) {
    return "";
  }

  const lines = [];

  if (context.screen) {
    lines.push(`【画面】${context.screen}`);
  }
  if (context.vtuberId) {
    lines.push(`【VTuber】${context.vtuberName ?? ""}(ID: ${context.vtuberId})`);
  }
  if (context.conditions && context.conditions.length > 0) {
    lines.push(`【検索条件】${context.conditions.join(" / ")}`);
  }

  if (lines.length === 0) {
    return "";
  }

  return `${lines.join("\n")}\n\n`;
}

const styles = {
  page: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
  },
  main: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "24px",
    maxWidth: "560px",
    margin: "0 auto",
    width: "80%",
  },
  title: {
    margin: 0,
  },
  description: {
    margin: 0,
    fontSize: "0.9rem",
    color: "#555",
  },
  form: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  textarea: {
    minHeight: "180px",
    padding: "10px",
    fontSize: "0.95rem",
    fontFamily: "inherit",
    border: "1px solid #ccc",
    borderRadius: "4px",
    resize: "vertical",
  },
  submitButton: {
    alignSelf: "flex-start",
    border: "none",
    background: "#4b3f8f",
    color: "#fff",
    borderRadius: "6px",
    padding: "10px 24px",
    fontSize: "0.95rem",
    cursor: "pointer",
  },
  submitButtonDisabled: {
    opacity: 0.5,
    cursor: "default",
  },
  successText: {
    margin: 0,
    color: "#2a7a2a",
    fontSize: "0.9rem",
  },
  errorText: {
    margin: 0,
    color: "#a33",
    fontSize: "0.9rem",
  },
};

function ContactPage() {
  const STATE_IDLE = "idle";
  const STATE_SENDING = "sending";
  const STATE_SENT = "sent";
  const STATE_ERROR = "error";

  const [state, setState] = useState(STATE_IDLE);
  const [message, setMessage] = useState(buildInitialMessage);
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = (e) => {
    setMessage(e.target.value);
    if (state === STATE_SENT || state === STATE_ERROR) {
      setState(STATE_IDLE);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const trimmedMessage = message.trim();
    if (!trimmedMessage) {
      return;
    }

    setState(STATE_SENDING);

    try {
      await sendContact(trimmedMessage);
      logAction("contact_submit", { messageLength: trimmedMessage.length });
      setMessage("");
      setState(STATE_SENT);
    } catch (err) {
      logAction("contact_submit_error", { messageLength: trimmedMessage.length, error: err.message });
      setErrorMessage(err.message);
      setState(STATE_ERROR);
    }
  };

  return (
    <div style={styles.page}>
      <Header />

      <MainTabs />

      <main style={styles.main}>
        <h2 style={styles.title}>お問い合わせ</h2>
        <p style={styles.description}>
          ご意見・ご要望・不具合報告などはこちらからお送りください。
        </p>

        <form style={styles.form} onSubmit={handleSubmit}>
          <textarea
            style={styles.textarea}
            value={message}
            onChange={handleChange}
            placeholder="お問い合わせ内容をご記入ください"
          />

          <button
            type="submit"
            style={{
              ...styles.submitButton,
              ...(state === STATE_SENDING ? styles.submitButtonDisabled : {}),
            }}
            disabled={state === STATE_SENDING}
          >
            {state === STATE_SENDING ? "送信中..." : "送信する"}
          </button>

          {state === STATE_SENT && (
            <p style={styles.successText}>送信しました。ありがとうございました。</p>
          )}

          {state === STATE_ERROR && (
            <p style={styles.errorText}>{errorMessage}</p>
          )}
        </form>
      </main>

      <Footer />
    </div>
  );
}

export default ContactPage;
